exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footnotes[data-v-4c2d22a8] {\n  font-size: 0.8em;\n}\n.footnotes ul li[data-v-4c2d22a8] {\n  margin-top: 5px;\n  list-style: none;\n}\n.uk-card-primary[data-v-4c2d22a8] {\n  color: white;\n  background-color: #0f7ae5;\n  padding: 40px;\n  font-size: 1.2em;\n  border-radius: 6px;\n}", ""]);

// exports
